import Splide from '@splidejs/splide'

export default function () {
  const splideSliders = document.querySelectorAll('.splide-slider')
  const splideGallery = document.querySelectorAll('.splide-gallery')
  const splideGalleryTwo = document.querySelectorAll('.splide-gallery--two')
  const splideHomeSlider = document.querySelectorAll('.js-splide-home-slider')

  if (splideGallery && splideGallery.length > 0) {
    splideGallery.forEach((slider) => {
      new Splide(slider, {
        perPage: 1,
        gap: 16,
        padding: { left: 0, right: 0 },
        mediaQuery: 'min',
        breakpoints: {
          768: {
            destroy: true,
          },
          640: {
            perPage: 2,
          },
        },
      }).mount()
    })
  }

  if (splideGalleryTwo && splideGalleryTwo.length > 0) {
    splideGalleryTwo.forEach((slider) => {
      new Splide(slider, {
        perPage: 1,
        gap: 16,
        padding: { left: 0, right: 0 },
        mediaQuery: 'min',
        breakpoints: {
          640: {
            destroy: true,
            pagination: true,
            arrows: false,
          },
        },
      }).mount()
    })
  }

  if (splideSliders && splideSliders.length > 0) {
    splideSliders.forEach((slider) => {
      new Splide(slider, {
        perPage: 2,
        gap: 32,
        padding: { left: 0, right: 350 },
        breakpoints: {
          1919: {
            padding: { left: 0, right: 300 },
          },
          1439: {
            padding: { left: 0, right: 240 },
          },
          1023: {
            padding: { left: 0, right: 0 },
            gap: 16,
          },
          639: {
            perPage: 1,
          },
        },
      }).mount()
    })
  }

  if (splideHomeSlider && splideHomeSlider.length > 0) {
    splideHomeSlider.forEach((slider) => {
      new Splide(slider, {
        perPage: 4,
        perMove: 1,
        pagination: true,
        gap: 32,
        arrows: false,
        breakpoints: {
          1240: {
            arrows: true,
            perPage: 2,
            gap: 20,
            padding: { left: 0, right: 250 },
          },
          1024: {
            padding: { left: 0, right: 150 },
          },
          768: {
            perPage: 2,
            padding: { left: 0, right: 0 },
          },
          640: {
            perPage: 1,
            padding: { left: 0, right: 20 },
          },
        },
      }).mount()
    })
  }
}
